export const stagingKey = '6LfP5eAeAAAAADQuBUucPuWooN5q-Ybs-xvaJ9rK';
export const previewKey = '6Ld7SuoeAAAAAIwqbqhzgqhLoVZFHNtvw_hCksHV';
export const sandboxKey = '6LeETOoeAAAAAO-pROzBMXZoQgjpGaIXLoMtz0ob';
export const canaryKey = '6LclTuoeAAAAAO2pQO_JgonK8zav4Tlb0292wU6u';
export const productionKey = '6Lf0TuoeAAAAAKebs3yE8d6G-QaMFaPxEnw-xUhE';
